<template>
    <div class="row">
        <div class="col-md-12">
            <div class="d-flex flex-wrap align-items-center justify-content-between">
                <div class="dro col-lg-9 pl-0">
                    <button type="button"
                            class="btn btn-light btn-sm  mb-1"
                            @click.prevent="backToPreviousPage()">
                        <i class="material-icons mdc-button__icon">arrow_back</i>
                        <span>{{'buttons.back_to_client' | trans}} {{client.code}} ({{client.hash}})</span>
                    </button>
                    <h4 class="dro__title">{{'dro.title' | trans}}</h4>
                    <p class="dro__subtitle">{{'dro.interactive_module_one' | trans}}</p>
                    <p class="dro__description">{{'dro.description' | trans}}</p>
                </div>


                <mdc-button v-if="!isMensurationForbidden" class="button-primary" raised :to="{name: 'dro-session'}">{{
                    'dro.hold_session' | trans }}
                </mdc-button>
            </div>
        </div>


        <div class="col-md-12 mt-4">
            <dro-report></dro-report>
        </div>

        <dashboard-menu  :hideDroModal=hideDroModal></dashboard-menu>
    </div>
</template>

<script>
  import DroReport from './DroReport';
  import {mapGetters} from "vuex";
  import DashboardMenu from '../../dashboardParent/components/DashboardMenu';
  import axios from 'axios';

  export default {
    components: {DroReport, DashboardMenu},
    props: {
      'clientId': {
        type: [Number, String],
        default() {
          return Auth.getUserInfo().id || this.route.params.clientId;
        },
      },
    },
    data() {
      return {
        loaded: false,
        hideDroModal: true,
        apiUrl: '/users/clients/',
        client: {},
      };
    },
    created() {
      this.getClient(this.clientId);
    },
    computed: {
      ...mapGetters('auth', [
        'isMensurationForbidden'
      ]),
    },
    methods: {
      backToPreviousPage() {
        this.$router.push({name: 'client-edit', params: {clientId: this.clientId}});
      },
      getClient: async function (clientId) {
        try {
          let response = await axios.get(this.apiUrl + clientId);
          this.client = response.data.data;
        } catch (error) {
          console.dir(error)
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/dro/components/DroLayout.vue